export default __webpack_public_path__ + "static/media/330_dummy2016-raumgestalter01-de.4f4c8c96.png";